import { Map } from "lucide-react";
import { BridgeReadOnly } from "@/components/common/BridgeReadOnly";

export default function Regionen() {
  return (
    <BridgeReadOnly
      resource="regionen"
      title="Regionen"
      subtitle="Regionen und Standorte – read-only via FUNDIO Bridge (Directorist ist Master)."
      icon={Map}
      columns={[
        { key: "name", label: "Region / Standort" },
        { key: "slug", label: "Slug" },
        { key: "count", label: "Anzahl" },
      ]}
    />
  );
}
